import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { createGlobalStyle } from "styled-components";
import theme from "./theme.d";
import App from "./App";

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, menu, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
main, menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, main, menu, nav, section {
  display: block;
}
/* HTML5 hidden-attribute fix for newer browsers */
*[hidden] {
    display: none;
}
body {
  line-height: 1;
}
menu, ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
* {
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
}
body {
  font-weight: 300;
  font-family: "Space Grotesk", sans-serif;
  color:${(props) => props.theme.white.lighter};
  line-height: 1.4;
  background: var(--bg);
  min-height: 100vh;
}
:root {
  /* Label-grade minimal palette (black / ivory) */
  --bg: #050506;
  --bg-2: #0b0b0d;
  --card: rgba(255, 255, 255, 0.04);
  --card-2: rgba(255, 255, 255, 0.06);
  --ink: #f3efe6;
  --muted: rgba(243, 239, 230, 0.72);

  /* Ink opacity variants (borders, subtle text) */
  --ink-06: rgba(243, 239, 230, 0.06);
  --ink-08: rgba(243, 239, 230, 0.08);
  --ink-10: rgba(243, 239, 230, 0.1);
  --ink-12: rgba(243, 239, 230, 0.12);
  --ink-78: rgba(243, 239, 230, 0.78);

  /* Single restrained accent (muted gold) */
  --accent: #d6b36a;
  --accent-2: rgba(214, 179, 106, 0.65);
  --accent-3: rgba(243, 239, 230, 0.85);
  --accent-45: rgba(214, 179, 106, 0.45);
  --glow: rgba(214, 179, 106, 0.22);
}
a {
  text-decoration:none;
  color:inherit;
}
button {
  font-family: "Space Grotesk", sans-serif;
}
img {
  max-width: 100%;
  display: block;
}

`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
      <GlobalStyle />
    </ThemeProvider>
  </React.StrictMode>
);
